<template>
  <el-dialog
    title="Sửa thông tin khách hàng"
    :visible.sync="dialogVisible"
    width="500px"
    custom-class="rounded"
    center
    @close="handleClose"
  >
    <ValidationObserver ref="observer" v-slot="{ handleSubmit: validate }">
      <form @submit.prevent="validate(onSubmit)" class="px-4 py-3">
        <div class="mb-4">
          <div class="mb-2">Họ tên khách hàng</div>
          <ValidationProvider
            name="Họ tên"
            rules="required"
            v-slot="{ errors }"
          >
            <el-input v-model="form.name" placeholder="Nhập họ và tên"></el-input>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="mb-3">
          <div class="mb-2">Số điện thoại khách hàng</div>
          <ValidationProvider
            name="Số điện thoại"
            rules="required|digits:10"
            v-slot="{ errors }"
          >
            <el-input v-model="form.phone" placeholder="Nhập số điện thoại"></el-input>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="d-flex justify-content-end gap-2 border-top pt-3 mt-4">
          <button 
            type="button" 
            class="btn btn-light px-4" 
            @click="handleClose"
          >
            Hủy
          </button>
          <button 
            type="submit" 
            class="btn btn-primary px-4 ml-2" 
            :disabled="loading"
            style="background: #7B61FF; border: none;"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
            Lưu thông tin
          </button>
        </div>
      </form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { UPDATE_INFO_STUDENT } from "@/core/services/store/test/testInput.module";

export default {
  name: 'UpdateStudentInfoModal',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultPhone: {
      type: String,
      default: ''
    },
    defaultName: {
      type: String,
      default: ''
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        phone: '',
        name: ''
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.form.phone = this.defaultPhone;
          this.form.name = this.defaultName;
        }
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$refs.observer.reset();
    },
    async onSubmit() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch(UPDATE_INFO_STUDENT, {
          ...this.form,
          token: this.uuid
        });
        if (response.error) {
          this.$message.error(response.message || "Có lỗi xảy ra");
          return;
        }
        this.$message.success("Cập nhật thông tin thành công");
        this.$emit('success', this.form);
        this.handleClose();
      } catch (error) {
        this.$message.error(error.response?.data?.message || "Có lỗi xảy ra");
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.el-dialog {
  border-radius: 8px;
}
.el-dialog__header {
  padding: 16px;
  border-bottom: 1px solid #E5E7EB;
}
.el-dialog__body {
  padding: 16px;
}
.el-dialog__footer {
  padding: 16px;
  border-top: 1px solid #E5E7EB;
}
.el-form-item {
  margin-bottom: 0;
}
.el-input {
  width: 100%;
}
</style> 